export default function TablePagination() {
  return {
    MuiTablePagination: {
      defaultProps: {
        rowsPerPageOptions: [25, 50, 100],
      },
    },
  };
}
